<template>
  <div>
    <h1 class="title text-uppercase font-weight-bold">
      Solicitar App
    </h1>
    <hr class="linha-amarela" />

    <div class="row mt-5">
        <div class="col-6">
            <div class="text-center">
                <img src="../../../src/assets/img/app.png" class="img-fluid rounded" alt="Celular mostrando app">
            </div>
        </div>
        
        <div class="col-6">
            <h1 class="mt-3">Gostaria de ter seu próprio aplicativo e pagar pela comissão só quando vender?</h1>
            <h3 class="mt-4">
              A mesma comissão da plataforma, <strong><span class="c-orange">4,0%</span> + taxa de transação</strong> da IUGU.
            </h3>
            <h4 class="c-black mt-4">
              * Pagamento mínimo mensal de {{ planosApp[0].preco }} descontado da comissão.
            </h4>
            <h3 class="mt-4">É muito fácil, é só clicar no botão abaixo.</h3>
            <button 
                class="btn bg-orange c-white mt-3 btn-block"
                @click="showContractPlan()"
            >
                Solicitar agora
            </button>
        </div>
    </div>

    <!-- CARDS -->
    <div class="bg-orange mt-5 c-white text-center p-5">
        <h1 class="pt-4 mb-4">Vantagens em ter seu próprio aplicativo</h1>
        <div class="row">
            <div class="col-md mt-2">
                <img src="../../../src/assets/img/grafico40.png" class="img-grafico img-fluid rounded" alt="Grafico de barras 40%">
                <h5 class="card-text mt-2">Desde o inicio da pandemia, as compras realizadas pela internet no Brasil aumentaram em 40%</h5>
            </div>
            
            <div class="col-md mt-4">
                 <img src="../../../src/assets/img/grafico76.png" class="img-grafico img-fluid rounded" alt="Grafico de pizza porcentagem 76%">
                <h5 class="card-text mt-4">de todas comprar online, 76% são feitas por celulares</h5>
            </div>

            <div class="col-md mt-3">
                <img src="../../../src/assets/img/grafico85.png" class="img-grafico img-fluid rounded" alt="Grafico de pizza porcentagem 85%">
                <h5 class="card-text mt-4">85% dos brasileiros com celular compram online</h5>
            </div>
  
        </div>
    </div>

    <!--CARDS HORIZONTAIS-->
    <div class="row mt-5">
        <h1 class="mb-4 text-center titleCustom">Customizações que você pode fazer no seu aplicativo</h1>

        <div class="col-md-6 mt-5">
            <ul>
                <li> 
                    <h3 class="card-text">Personalizar as <span class="c-orange">cores</span>, o <span class="c-orange">logo</span> e 
                    <span class="c-orange">nome</span> do aplicativo</h3>
                </li>
                <li class="mt-4">
                     <h3 class="card-text">Personalizar os <span class="c-orange">banners</span> do aplicativo.</h3>
                </li>
            </ul>
        </div>

        <div class="col-md">
            <img src="../../../src/assets/img/seu-banner.png" class="img-fluid rounded" alt="Celular mostrando app">
        </div>
    </div>

     <div class="row mt-3 mb-3">
        <div class="col-md mt-5">
            <img src="../../../src/assets/img/lista-produtos.png" class="img-fluid rounded" alt="Celular mostrando app">
        </div>
        <div class="col-md-6 mt-5">
            <ul>
                <li> 
                    <h4 class="card-text color-brack">
                        Selecione os <span class="c-orange">produtos</span> para vender, sem precisar cadastrar os
                        produtos, já temos mais de <span class="c-orange">200.000</span> produtos cadastrados.
                    </h4>
                </li>
                <li class="mt-4">
                     <h3 class="card-text">Recados, <span class="c-orange">promoções</span>, novidades, notificação instantânea via Push.</h3>
                </li>
                <li class="mt-4">
                    <h3 class="card-text">Todas suas <span class="c-orange">redes sociais</span> no aplicativo.</h3>
                </li>
            </ul>
        </div>
    </div>

    <!--PORQUE TER UM APLICATIVO-->
    <div class="pt-3 bg-orange c-white">
        <div class="mb-3">
            <h1 class="text-center">Por que ter um aplicativo criado por nós?</h1>
        </div>
        <div class="row p-5">
            <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fas fa-building icon-size"></i> 
                </div>
                <div class="text-center mt-4">
                    <h5>Em poucos cliques, configure tudo</h5>
                </div>
            </div>

             <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fa fa-dollar-sign icon-size"></i>
                </div>
                <div class="text-center mt-4">
                    <h5>Sem mensalidade ou anuidades</h5>
                </div>
            </div>

             <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fas fa-building icon-size"></i>   
                </div>
                <div class="text-center mt-4">
                    <h5>Receba o dinheiro na sua conta</h5>
                </div>
            </div>

             <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fa fa-dollar-sign icon-size"></i> 
                </div>
                <div class="text-center mt-4">
                    <h5>Baixa comissão de venda</h5>
                </div>
            </div>

             <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fa fa-globe icon-size"></i>
                </div>
                <div class="text-center mt-4">
                    <h5>Venda online sem investir em uma plataforma própria</h5>
                </div>
            </div>

        </div>
        
    </div>

    <!--MODAL ERRO-->
     <b-modal
      size="md"
      id="modalIugu"
      header-text-variant="light"
      centered
      hide-footer
      hide-header
    >
      <div class="text-center">
        <span class="mb-5">
            <h3 class="c-orange">Parece que você ainda não validou a sua conta na IUGU :/</h3>
            <h5 class="mt-4">O que é IUGU?</h5>
          <p class="mt-3">
           A IUGU é um sistema de pagamento online. É o sistema onde os seus clientes irão pagar
           no seu aplicativo e você ira receber o valor do pedido diretamente na sua conta.
          </p>
          <div class="mt-4">

            <router-link
                class="d-block p-2 btn btn-success"
                class-active="active"
                :to="{ name: 'lojista-iugu-update' }"
            >
                Validar agora
            </router-link>
          </div>
        </span>
      </div>
    </b-modal>

    <!-- MODAL SUCESSO -->
     <b-modal
     title="Sucesso"
      size="md"
      id="modalSuccess"
      header-bg-variant="orange"
      header-text-variant="light"
      no-close-on-backdrop
      centered
      hide-footer
    >
      <div class="container text-center">
        <span class="mb-5">
            <h5 class="">Sua solicitação foi enviado com sucesso :-)</h5>
            <h5>O proximo passo agora é fazer a customização do App e deixar com a cara da sua empresa!</h5>
          <div class="mt-4">

            <router-link
                class="p-2 btn btn-success"
                class-active="active"
                :to="{ name: 'lojista-customizacoes-mudar-cor' }"
            >
              Customizar App
            </router-link>

            <router-link
                class="p-2 btn btn-primary ml-5"
                class-active="active"
                :to="{ name: 'lojista-meus-dados' }"
            >
              Meus dados
            </router-link>

          </div>
        </span>
      </div>
    </b-modal>

    <!--MODAL DO SOLICITANTE-->
    <b-modal
      size="md"
      id="modalDados"
      header-text-variant="light"
      centered
      no-close-on-backdrop
      hide-footer
      hide-header
    >
      <div class="container">
        <h4 class="c-orange text-center">Favor inserir os dados de quem está solicitando</h4>

        <div class="mt-4">
          <label>Nome do solicitante</label>
          <input
            type="text" 
            class="form-control cursor-pointer"
            v-model="data.name"
            placeholder="Insira o nome do solicitante"
          >
        </div>

        <div class="mt-2">
          <label>Telefone solicitante</label>
          <input 
            type="text" 
            v-mask="['(##) #####-####', '(##) ####-####']"
            class="form-control cursor-pointer"
            v-model="data.phone"
            placeholder="Insira o telefone do solicitante"
          >
        </div>
      
        <div class="mt-4 text-right">
          <div class="row">
            <div class="col-6">
              <b-button class="mr-2 btn-block" variant="danger" @click="close()">
                Fechar
              </b-button>
            </div>
            <div class="col-6">
              <b-button variant="success" class="btn-block" @click="verifyData()">
                Próximo
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <ShopkeeperAppContract>
      <template #actions>
        <div class="text-right">
          <div class="row mt-2">
            <div class="col-6">
              <b-button class="mt-3 mr-2 btn-block" variant="danger" @click="$bvModal.hide('shopkeeper-app-contract')">
                <i class="fas fa-times mr-2"></i>
                Fechar Contrato
              </b-button>
            </div>
            <div class="col-6">
              <b-button class="mt-3 btn-block" variant="success" @click="send()">
                <i class="fas fa-check mr-2"></i>
                Aceitar
              </b-button>
            </div>
          </div>
        </div>
      </template>
    </ShopkeeperAppContract>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import scrollToElement from '../../mixins/scrollToElement';
import makeToast from '../../mixins/makeToast';
import ShopkeeperAppContract from 'Components/Contract/ShopkeeperAppContract.vue';

export default {
  mixins: [scrollToElement, makeToast],
  name: 'SolicitarApp',

  data() {
    return {
      hasIugo: true,
      data: {
        lojista_id: null,
        status: null,
        name: '',
        phone:'',
        assinatura: false
      },
      response: null,
      planosApp: '',
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  created() {
    this.scrollToElement();
    this.showPlanos();
  },
  mounted() {
    this.showIugu();
    this.scrollToElement();
  },
  methods: {
    verifyData(){
  
      if(!this.data.name){
        this.makeToast('Erro!', 'Favor inserir o nome do solicitante!', 'danger');
        return;
      }
        
      if(!this.data.phone){
        this.makeToast('Erro', 'Favor inserir o telefone do solicitante!', 'danger');
        return;
      }
      
      let phone = this.data.phone;
      this.data.phone = phone.replace(/[^0-9]+/g,'');
          
      if(this.data.phone.length < 10){
        this.makeToast('Erro', 'Favor preencher corretamento o número de telefone!', 'danger');
        return;
      }
              
      this.$bvModal.show('shopkeeper-app-contract');
    },

    close(){
      this.data = {};
      this.$bvModal.hide('modalDados')
    },

    send() {
      if (!this.hasIugo) {
        this.$bvModal.show('modalIugu');
      }

      this.$bvModal.hide('shopkeeper-app-contract');
      this.$bvModal.hide('modalDados');
      let phone = this.data.phone;

      const data = {
        lojista_id: this.dadosUsuario.informacoes.id,
        status: 1,
        phone: phone.replace(/[^0-9]+/g,''),
        assinatura: true,
        usuario_id: this.dadosUsuario.id,
        nome: this.dadosUsuario.nome_usuario,
        email: this.dadosUsuario.email,
        cpf_cnpj: this.dadosUsuario.cnpj,
        street: this.dadosUsuario.informacoes.endereco,
        district: this.dadosUsuario.informacoes.bairro,
        number: this.dadosUsuario.informacoes.numero,
        zip_code: this.dadosUsuario.informacoes.cep,
        complement: this.dadosUsuario.informacoes.complemento,
        city: this.dadosUsuario.informacoes.cidade.nome,
        state: this.dadosUsuario.informacoes.estado.uf,
      }

      this.$store.dispatch('lojistaSolicitaApp', data)
        .then((resp) => {
          this.response = resp;
          this.$root.$emit('valid-status-app');
        })
        .catch((error) => {
          this.makeToast('Opa!', 'Infelizmente ocorreu um erro, favor tentar novamente!!!', 'danger');
        }) 
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.$router.push({ name: 'lojista-cartão-credito-app-ass' });      
        });
    },

    showIugu() {
      this.$store
        .dispatch('showInfoDashboard')
        .then((resp) => {})
        .catch((error) => {
          if (error.response.status === 500) {
            hasIugo = false;
          }
        });
    },
    showContractPlan() {
      this.$store.dispatch('startLoader');   
      this.$store.dispatch('validarContaIugu', this.dadosUsuario.id)
        .then((response) => {
          if(response.data.valid == true) {
            this.$bvModal.show('modalDados');
          } else {
            this.makeToast('Opss!', 'Antes de solicitar o App é preciso configurar sua conta de recebimento!', 'danger');
            this.$router.push({ name: 'lojista-iugu-update' });
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');        
        });
    },
    showPlanos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosApp')
      .then((response) => {
        this.planosApp = response.data;
        this.$store.dispatch('endLoader');
      })
    },
  },
  components: {
    ShopkeeperAppContract,
  },
};
</script>

<style scoped>
.size-img {
  max-width: 380px;
}
.img-grafico {
  max-width: 250px;
  /* display: flex;
        justify-content: center; */
}
.icon-size {
  font-size: 60px;
}

@media (max-width: 800px){
.size-img {
  width: 100%;
}
h1 {
  font-size: 25px;
}
h3 {
  font-size: 18px;
}
h5 {
  font-size: 16px;
}
.bg-orange{
  width: 100%;
}
.titleCustom {
  margin-left: 7%;
}
.text-uppercase {
  margin-left: 2%;
}
.linha-amarela {
  margin-left: 2%;
}
}
</style>